import React from 'react';

interface ErrorScreenProps {
  message: string;
}

export default function ErrorScreen({ message }: ErrorScreenProps) {
  return (
    <div className="page" style={{ maxWidth: 560 }}>
      <div className="card" style={{ padding: 28, borderColor: 'var(--danger)' }}>
        <div className="eyebrow" style={{ marginBottom: 8, color: 'var(--danger)' }}>ERROR</div>
        <h2 style={{ margin: '0 0 12px' }}>Something went wrong</h2>
        <p style={{ color: 'var(--ink-3)', fontSize: 13, lineHeight: 1.6, margin: 0 }}>{message}</p>
      </div>
    </div>
  );
}
